import {
  CheckCircle,
  Clock,
  UserCheck,
  TrendingUp,
  type LucideIcon,
} from "lucide-react";
import type { ReactNode } from "react";
import { toTitleCase } from "../../../../../utils/config";

export const STATUS_BADGES: Record<string, string> = {
  completed: "bg-success",
  "in progress": "bg-primary",
  pending: "bg-warning",
  overdue: "bg-danger",
};

export const getStatusBadge = (status?: string) =>
  STATUS_BADGES[status?.toLowerCase() ?? ""] || "bg-secondary";

export const getStatusText = (status?: string) => {
  if (!status) return "Not Started";

  return status
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

type StatusConfig = {
  badge: string;
  color: string;
  icon: LucideIcon;
};

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  Completed: {
    badge: "bg-light-success",
    color: "success",
    icon: CheckCircle,
  },
  "In Progress": {
    badge: "bg-light-primary",
    color: "primary",
    icon: Clock,
  },
  Overdue: {
    badge: "bg-light-danger",
    color: "danger",
    icon: UserCheck,
  },
  Pending: {
    badge: "bg-light-warning",
    color: "warning",
    icon: TrendingUp,
  },
  "Not Started": {
    badge: "bg-secondary",
    color: "secondary",
    icon: Clock,
  },
};

export function getStatusConfig(status?: string): StatusConfig {
  const convertedStatus = toTitleCase(status ?? "Not Started");

  return (
    STATUS_CONFIG[convertedStatus] ??
    STATUS_CONFIG["Not Started"]
  );
};
